<template>
  <div class="wechat">
    <headers></headers>
    <div class="wechat-info1">
      <div class="wechat-info2">
        <img src="../assets/images/wechat/wechat1.png" alt />
      </div>
      <div class="wechat-info3">
        <div class="wechat-info4">
          <h1>商务合作</h1>
          <p>手机号码：</p>
          <el-input
            type="text"
            onkeyup="(this.v=function(){this.value=this.value.replace(/[^0-9-]+/,'');}).call(this)"
            style="width:100%;"
            placeholder="请输入手机号码"
            suffix-icon="el-icon-mobile-phone"
            v-model="phone"
          ></el-input>
          <p>验证码：</p>
          <div style="display:flex;justify-content: space-between;">
            <el-input
              type="text"
              onkeyup="(this.v=function(){this.value=this.value.replace(/[^0-9-]+/,'');}).call(this)"
              style="width:70%;"
              placeholder="请输入验证码"
              maxlength="6"
              suffix-icon="el-icon-chat-line-round"
              v-model="yzm"
            ></el-input>
            <div v-show="isHide1" class="wechat-info8" @click="duanxin1()">获取验证码</div>
            <div v-show="isHide2" class="forgetPassword-info5">等待({{jishiqisl}})</div>
          </div>
          <p>合作意向：</p>
          <el-radio-group v-model="radio" style="display:flex;justify-content: space-between;">
            <el-radio :label="3">我需要购买</el-radio>
            <el-radio :label="6">我需要批发</el-radio>
            <el-radio :label="9">成为代理</el-radio>
          </el-radio-group>
          <p>备注内容：</p>
          <el-input
            type="textarea"
            placeholder="请输入内容"
            v-model="textarea"
            maxlength="30"
            style="width:100%;"
            show-word-limit
          ></el-input>
          <button @click="tijiao()">立即提交</button>
        </div>
      </div>
    </div>
    <div class="small-info1">
      <h3>商务合作</h3>
      <div class="box1">
        <p>手机号码：</p>
        <el-input
          type="text"
          onkeyup="(this.v=function(){this.value=this.value.replace(/[^0-9-]+/,'');}).call(this)"
          style="width:100%;"
          placeholder="请输入手机号码"
          suffix-icon="el-icon-mobile-phone"
          v-model="phone"
        ></el-input>
      </div>
      <div class="box1">
        <p>验证码：</p>
        <div style="display:flex;justify-content: space-between;">
          <el-input
            type="text"
            onkeyup="(this.v=function(){this.value=this.value.replace(/[^0-9-]+/,'');}).call(this)"
            style="width:70%;"
            placeholder="请输入验证码"
            maxlength="6"
            suffix-icon="el-icon-chat-line-round"
            v-model="yzm"
          ></el-input>
          <div v-show="isHide1" class="wechat-info8" @click="duanxin1()">获取验证码</div>
          <div v-show="isHide2" class="forgetPassword-info5">等待({{jishiqisl}})</div>
        </div>
      </div>
      <div class="box1">
        <p>合作意向：</p>
        <el-radio-group v-model="radio" style="display:flex;justify-content: space-between;">
          <el-radio :label="3">我需要购买</el-radio>
          <el-radio :label="6">我需要批发</el-radio>
          <el-radio :label="9">成为代理</el-radio>
        </el-radio-group>
      </div>
      <div class="box1">
        <p>备注内容：</p>
        <el-input type="textarea" v-model="form.desc"></el-input>
      </div>
      <button>立即合作</button>
    </div>
  </div>
</template>

<script>
import header from "../components/headers";
export default {
  name: "",
  components: {
    headers: header
  },
  data() {
    return {
      value1: "",
      options: [
        {
          value: "选项1",
          label: "黄金糕"
        },
        {
          value: "选项2",
          label: "双皮奶"
        },
        {
          value: "选项3",
          label: "蚵仔煎"
        },
        {
          value: "选项4",
          label: "龙须面"
        },
        {
          value: "选项5",
          label: "北京烤鸭"
        }
      ],
      value: "",
      text: "",
      textarea: "", //备注
      phone: "", //手机号
      yzm: "", //验证码
      radio: 3, //合作意向：
      jishiqisl: 60, //60s
      isHide1: true, //获取验证码
      isHide2: false, //等待60s
      form: {
        region: ""
      },
      value6: ""
    };
  },

  methods: {
    // 获取验证码
    duanxin1() {
      var reg2 = /^1([38]\d|5[0-35-9]|7[3678])\d{8}$/;
      if (this.phone == "") {
        this.$message({
          message: "手机号不能为空",
          type: "warning"
        });
        return;
      } else if (reg2.test(this.phone) === false) {
        this.$message({
          message: "手机号格式不正确",
          type: "warning"
        });
        return;
      } else {
        this.isHide1 = false;
        this.isHide2 = true;
        this.$message({
          message: "短信已发送",
          type: "success"
        });
        var jisi = setInterval(() => {
          this.jishiqisl--;
          if (this.jishiqisl == 0) {
            clearInterval(jisi);
            this.jishiqisl = 60;
            this.isHide1 = true;
            this.isHide2 = false;
          }
        }, 1000);
      }
    },
    // 提交
    tijiao() {
      var reg2 = /^1([38]\d|5[0-35-9]|7[3678])\d{8}$/;
      if (this.phone == "") {
        this.$message({
          message: "手机号不能为空",
          type: "warning"
        });
        return;
      } else if (reg2.test(this.phone) === false) {
        this.$message({
          message: "手机号格式不正确",
          type: "warning"
        });
        return;
      }
      if (this.phone == "" || this.yzm == "") {
        this.$message({
          message: "必填信息不能为空哦！",
          type: "warning"
        });
      } else {
        this.$message({
          message: "提交成功",
          type: "success"
        });
      }
    }
  },
  watch: {}
};
</script>

<style scoped lang="less">
* {
  padding: 0;
  margin: 0;
  list-style: none;
  box-sizing: border-box;
}
// 处理input type = number的上下箭头
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
input[type="number"] {
  -moz-appearance: textfield;
}
.wechat {
  width: 100%;
  height: 100%;
  margin-top: -60px;
  padding-bottom: 50px;
  @media screen and (max-width: 850px) {
    .wechat-info1 {
      display: none !important;
    }
  }
  @media screen and (min-width: 850px) {
    .small-info1 {
      display: none;
    }
  }
  .small-info1 {
    padding: 100px 35px;
    h3 {
      font-size: 18px;
      font-weight: 700;
      letter-spacing: 3.6px;
      color: #323232;
      margin-bottom: 22px;
    }
    .box1 {
      margin-bottom: 15px;
      .el-date-editor--daterange.el-input__inner {
        width: 100%;
      }
      /deep/.el-radio__label {
        padding: 0;
      }
      p {
        margin-bottom: 5px;
      }
      span {
        font-size: 12px;
        margin-left: 10px;
        i {
          font-style: normal;
          color: #fda700;
        }
      }
      .wechat-info8 {
        width: 126px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        color: #fff;
        background-color: #258ffc;
        font-size: 14px;
        margin-left: 12px;
        cursor: pointer;
      }
    }
    button {
      background-color: #258ffc;
      border-radius: 3.5px;
      border: 1px solid #dcdcdc;
      width: 86px;
      height: 30px;
      color: #fff;
      margin-top: 40px;
    }
  }

  .wechat-info1 {
    width: 70%;
    margin: 0 auto;
    display: flex;
    min-width: 1300px;
    .wechat-info2 {
      width: 38%;
      height: 750px;
      box-shadow: 14px -1px 20px 0px rgba(18, 132, 247, 0.3);
      border-radius: 2px;
      margin-top: 114px;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .wechat-info3 {
      width: 60%;
      height: 750px;
      margin-top: 114px;
      border-radius: 2px;
      box-shadow: 0px 4px 35px 3px rgba(107, 108, 109, 0.2);
      padding-left: 70px;

      padding-right: 133px;

      .wechat-info4 {
        margin: 20px 80px;
        h1 {
          font-size: 36px;
          // margin-bottom: 20px;
          margin-top: 49px;
        }
        p {
          font-size: 18px;
          font-family: MicrosoftYaHei;
          font-weight: 400;
          color: rgba(50, 50, 50, 1);
          padding: 39px 0 10px 0;
          &:nth-of-type(1) {
            margin-top: 20px;
          }
        }
        /deep/.el-radio__label {
          font-size: 18px;
        }
        .wechat-info5 {
          display: flex;
          span {
            line-height: 40px;
            span {
              color: #fda700;
            }
          }
        }
        .wechat-info6 {
          display: flex;
          justify-content: space-between;
          .wechat-info7 {
            display: flex;
            justify-content: space-between;
            p {
              padding: 0;
              line-height: 40px;
            }
            img {
              width: 38px;
              height: 38px;
              margin-left: 10px;
              margin-top: 26px;
            }
          }
        }
        .wechat-info8 {
          width: 126px;
          height: 40px;
          line-height: 40px;
          text-align: center;
          color: #fff;
          background-color: #258ffc;
          font-size: 14px;
          margin-left: 12px;
          cursor: pointer;
        }
        button {
          background: #258ffc;
          width: 136px;
          height: 50px;
          line-height: 50px;
          text-align: center;
          color: #fff;
          margin-top: 95px;
          outline: none;
          border: none;
          cursor: pointer;
          font-size: 18px;
        }
      }
    }
  }
}
</style>
